import type { SortDirection } from '../profiles/location/types';
import type { RestorePointsQueryParams, RestorePointsSortBy } from './types';

export const RESTORE_POINTS_ANY_FILTER_VALUE = '' as const;
export const RESTORE_POINTS_ARRAY_FILTER_VALUE = [] as string[];

export const RESTORE_POINT_TYPES = [
  RESTORE_POINTS_ANY_FILTER_VALUE,
  'snapshot',
  'exported',
  'imported',
] as const;

export const RESTORE_POINTS_PAGE_DESCRIPTION =
  'View and manage all Restore Points created in this cluster';

export const RESTORE_POINTS_DOCS_LINK = 'https://docs.kasten.io/latest/usage/restore.html';

export const RESTORE_POINTS_SORT_BY = ['createdAt', 'expiresAt'] as const;

export const RESTORE_POINTS_DEFAULT_SORT_BY = 'createdAt' as RestorePointsSortBy;

export const RESTORE_POINTS_DEFAULT_SORT_DIR = 'DESC' as SortDirection;

export const RESTORE_POINTS_EMPTY_HINT = 'Take a snapshot, export an application or run a policy';

export const RESTORE_POINT_PANEL_LABELS = {
  details: 'Restore Point',
  restore: 'Restore',
  export: 'Export',
} as const;

export const RESTORE_POINT_PANEL_DESCRIPTIONS = {
  details: 'Details for the selected restore point, including artifacts and actions.',
  restore: 'Configure and start a restore from the selected restore point.',
  export: 'Configure and start an export of the selected restore point.',
} as const;

export const RESTORE_POINTS_DEFAULT_FILTERS = {
  appType: 'namespace' as const,
  appRefs: RESTORE_POINTS_ARRAY_FILTER_VALUE,
  createdAfter: undefined,
  createdBefore: undefined,
  includeManualRunsOnly: false,
  noExpiration: false,
  policyNames: RESTORE_POINTS_ARRAY_FILTER_VALUE,
  profileNames: RESTORE_POINTS_ARRAY_FILTER_VALUE,
  types: RESTORE_POINTS_ANY_FILTER_VALUE,
};

export const RESTORE_POINTS_APP_NAME_FILTER_CLUSTER_SCOPED = 'cluster-scoped';

export const RESTORE_POINTS_QUERY_PARAMS_STORAGE_KEY = 'k10.restorePoints.queryParams';

export const RESTORE_POINTS_IS_FILTER_OPEN_STORAGE_KEY = 'k10.restorePoints.isFilterOpen';

export const PAGE_SIZE = 20;

export const NUM_OF_SKELETON_ROWS = 15;

/**
 * Query param values that equal their defaults are omitted from the URL
 * to keep shared links clean (see omitEmpty's `defaults` argument).
 */
export const RESTORE_POINTS_QUERY_PARAMS_URL_DEFAULTS: Partial<RestorePointsQueryParams> = {
  appType: RESTORE_POINTS_DEFAULT_FILTERS.appType,
  includeManualRunsOnly: false,
  noExpiration: false,
  sortBy: RESTORE_POINTS_DEFAULT_SORT_BY,
  sortDir: RESTORE_POINTS_DEFAULT_SORT_DIR,
};
